import { createBrowserRouter, Navigate } from "react-router-dom";
import WithHeaderLayout from "../components/WithHeaderLayout";
import WithoutHeaderLayout from "../components/WithoutHeaderLayout";

import HomeComponent from "../components/HomeComponent";
import DocumentView from "../pages/DocumentView";
import Login from "../pages/Login";
import UploadDocuments from "../pages/UploadDocuments";
import AI_PDF_CONST from "../util/PdfAiConst";
import PrivateRoute from "../util/PrivateRoute";
import Holios from "../pages/Holios";
import HoliosUploadData from "../pages/HoliosUploadData";
import AIAutomation from "../pages/AIAutomation";
import AiLanding from "../pages/AiLanding";
import AIAutomationOptionA from "../pages/AIAutomationOptionA";
import AIAutomationOptionB from "../pages/AIAutomationOptionB";
import AIAutomation2 from "../pages/AIAutomation2";
import Communication from "../pages/Communication";
import AiComm from "../pages/AiComm";
import PdfToExl from "../pages/PdfToExl";
import MyDocs from "../pages/MyDocs";
import VoiceCall from "../pages/VoiceCall";
import AdminOrgsPage from "../pages/AdminOrgsPage";
import AdminOrgUsersPage from "../pages/AdminOrgUsersPage";
import Home2 from "../pages/Home2/App";
import Chat from "../pages/Chat";
import CentralWhatsAppInbox from "../pages/admin/CentralWhatsAppInbox";
import AdminDashboardPage from "../pages/admin/Dashboardpage";
import TenantListPage from "../pages/admin/tenantlistpage";
import TenantCreatePage from "../pages/admin/tenantcreatepage";
import TenantDetailPage from "../pages/admin/tenantdetailpage";
import TenantOnboardingPage from "../pages/admin/tenantonboardingpage";
import TenantProfilesListPage from "../pages/admin/tenantprofileslistpage";
import TeamListPage from "../pages/admin/teamlistpage";
import ServiceListPage from "../pages/admin/servicelistpage";
import ConfigListPage from "../pages/admin/configlistpage";
import AuditLogsPage from "../pages/admin/auditlogspage";
import OnboardingListPage from "../pages/admin/onboardinglistpage";
import AdminLayout from "../components/admin/AdminLayout";
import ErrorPage from "../pages/ErrorPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import DataDeletion from "../pages/DataDeletion";
import PublicTenantProfile from "../pages/PublicTenantProfile";
import PublicTenantDirectory from "../pages/PublicTenantDirectory";

const adminRoute = (element) => <PrivateRoute element={<AdminLayout>{element}</AdminLayout>} />;
const router = createBrowserRouter([
  {
    element: <WithHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: AI_PDF_CONST.ROUTE.ROOT,
        element: <Navigate to={AI_PDF_CONST.ROUTE.HOME} />,
      },
      { path: AI_PDF_CONST.ROUTE.HOME, element: <HomeComponent /> },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENTS,
        element: <PrivateRoute element={<UploadDocuments />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENT_VIEW,
        element: <PrivateRoute element={<DocumentView />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_DASHBOARD,
        element: adminRoute(<AdminDashboardPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANTS,
        element: adminRoute(<TenantListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANTS_CREATE,
        element: adminRoute(<TenantCreatePage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_DETAIL,
        element: adminRoute(<TenantDetailPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_ONBOARDING,
        element: adminRoute(<TenantOnboardingPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_PROFILES,
        element: adminRoute(<TenantProfilesListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TEAM,
        element: adminRoute(<TeamListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_SERVICES,
        element: adminRoute(<ServiceListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_CONFIGS,
        element: adminRoute(<ConfigListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_AUDIT_LOGS,
        element: adminRoute(<AuditLogsPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ONBOARDING,
        element: adminRoute(<OnboardingListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS,
        element: <Holios />,
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS_UPLOAD_DATA,
        element: <HoliosUploadData />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION,
        element: <AIAutomation />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI,
        element: <AiLanding />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_A,
        element: <AIAutomationOptionA />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_B,
        element: <AIAutomationOptionB />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION_2,
        element: <AIAutomation2 />,
      },
      {
        path: AI_PDF_CONST.ROUTE.COMMUNICATION,
        element: <Communication />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_COMM,
        element: <AiComm />,
      },
      {
        path: AI_PDF_CONST.ROUTE.PDF_TO_EXL,
        element: <PdfToExl />,
      },
      {
        path: AI_PDF_CONST.ROUTE.MY_DOCS,
        element: <PrivateRoute element={<MyDocs />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.VOICE_CALL,
        element: <PrivateRoute element={<VoiceCall />} />,
      },
      {
        path: "/chat",
        element: <Chat />,
      },
      {
        path: "/admin/whatsapp-inbox/:tenantId?/:conversationId?",
        element: <PrivateRoute element={<CentralWhatsAppInbox />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORGS,
        element: <PrivateRoute element={<AdminOrgsPage />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORG_USERS,
        element: <PrivateRoute element={<AdminOrgUsersPage />} />,
      },
      { path: "/privacy", element: <PrivacyPolicy /> },
      { path: "/terms", element: <TermsOfService /> },
      { path: "/data-deletion", element: <DataDeletion /> },
    ],
  },
  {
    element: <WithoutHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: AI_PDF_CONST.ROUTE.HOME2, element: <Home2 /> },
      { path: AI_PDF_CONST.ROUTE.LOGIN, element: <Login /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_PROFILE, element: <PublicTenantProfile /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_DIRECTORY, element: <PublicTenantDirectory /> },
    ],
  },
]);

export default router;
